export default "__VITE_ASSET__DsZ5rThO__"